
document.addEventListener('DOMContentLoaded', function () {
  const headerSection = document.querySelector('.header-section.header-sticky');
  if (!headerSection) return;

  let lastScrollTop = window.scrollY;
  const headerHeight = headerSection.offsetHeight;

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;

    // Toggle "header-scrolled"
    if (scrollTop > headerHeight) {
      headerSection.classList.add('header-scrolled');
      document.documentElement.style.setProperty(
        '--sticky-header-height',
        headerHeight + 'px'
      );

      document.dispatchEvent(
        new CustomEvent('header:scrolled', {
          bubbles: true,
          detail: { scrolled: true },
        })
      );
    } else {
      headerSection.classList.remove('header-scrolled');
      headerSection.classList.remove('header-nav-scrolled');

      document.dispatchEvent(
        new CustomEvent('header:scrolled', {
          bubbles: true,
          detail: { scrolled: false },
        })
      );
    }

    // Toggle "header-nav-scrolled" if scroll > 2x height
    if (scrollTop > headerHeight * 2) {
      headerSection.classList.add('header-nav-scrolled');

      headerSection.querySelectorAll('details[open]').forEach((details) => {
        details.open = false;
      });
    }

    // Hide header on scroll down, show on scroll up
    if (scrollTop > headerHeight + 100) {
      if (scrollTop > lastScrollTop) {
        headerSection.classList.add('header-hidden');
      } else {
        headerSection.classList.remove('header-hidden');
      }
    } else {
      headerSection.classList.remove('header-hidden');
    }

    lastScrollTop = scrollTop;
  });
});

